import { POST_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getOptimizeRoute = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_OPR_OPTIMIZEROUTR, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getOptimizeRoute} 